import { Button } from "./button";
import { Input } from "./input";
import { Radio } from "./radio";
import {
  Select,
  SelectButton,
  SelectList,
  SelectItem,
  SelectButtonDisabled
} from "./select";

export const formElements = {
  Button,
  Input,
  Radio,
  Select,
  SelectButton,
  SelectList,
  SelectItem,
  SelectButtonDisabled
};
